var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBackgroundPatternDecorative = function SvgBackgroundPatternDecorative(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 480,
    viewBox: "0 0 480 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9868_47415",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 480,
    height: 480
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 480,
    fill: "url(#paint0_radial_9868_47415)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9868_47415)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 47.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 79.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 111.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 143.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 143.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 175.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 207.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 239.5,
    stroke: "#E4E7EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9868_47415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240 240) rotate(90) scale(240 240)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBackgroundPatternDecorative);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "background-pattern-decorative.4b47b90feeb499ffc72c7c4e422094ed.svg";